import { lazy } from 'react';

import type { TRoute } from 'shared/presentation/modules/definitions';

import { CheckoutLocalContainer } from '../contexts';

const BudgetSummary = lazy(
  () => import('modules/checkout/presentation/pages/BudgetSummary'),
);
const FacialRecognition = lazy(
  () => import('modules/checkout/presentation/pages/FacialRecognition'),
);
const FinishCustomerRegister = lazy(
  () => import('modules/checkout/presentation/pages/FinishCustomerRegister'),
);
const PaymentLink = lazy(
  () => import('modules/checkout/presentation/pages/PaymentLink'),
);
const Setup = lazy(() => import('modules/checkout/presentation/pages/Setup'));

const routes: TRoute[] = [
  {
    type: 'navigator',
    path: '/checkout',
    routes: [
      {
        type: 'route',
        path: '/checkout/reconhecimento-facial/:id',
        component: FacialRecognition,
      },
      {
        type: 'route',
        path: '/checkout/finalizar-registro/:id',
        component: FinishCustomerRegister,
      },
      {
        type: 'route',
        path: '/checkout/resumo-orcamento/:id',
        component: BudgetSummary,
      },
      {
        type: 'route',
        path: '/checkout/link-pagamento/:id',
        component: PaymentLink,
      },
      {
        type: 'route',
        path: '/checkout/opcaopagamento/:hash?',
        component: Setup,
      },
      {
        type: 'route',
        path: '/checkout/:hash?',
        component: Setup,
      },
    ],
    container: CheckoutLocalContainer,
  },
];

export default routes;
